module.exports = __webpack_public_path__ + "static/media/27_A.a137a5cd.png";